import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import useProfile from "core/features/auth/profile/useProfile";
import useSaveProfile from "core/features/auth/profile/useSaveProfile";
import { UserProfile } from "core/features/auth/typings/user";
import { useForm } from "react-hook-form";
import Field from "ui/components/Input/Field";
import UploadImagem from "ui/components/Input/UploadImagem";
import InputMask from "ui/components/Input/InputMask";
import SelectSexo from "ui/components/Input/SelectSexo";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { useEffect } from "react";
import CardDefault from "ui/components/Cards/CardDefault";
import { useLoading } from "ui/components/GlobalLoading";
import { isValidCPF } from "@brazilian-utils/brazilian-utils";
import FormContatos from "ui/components/FormContatos";

function DadosPessoaisTab() {
  const { data, isLoading, isFetching, refetch } = useProfile();
  const { handleSave, isLoading: isLoadingSave } = useSaveProfile();

  const { control, reset, handleSubmit, formState } = useForm<UserProfile>({
    mode: "all",
  });

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  const onSubmit = async (data: UserProfile) => {
    await handleSave(data).then((_data) => refetch());
  };

  useLoading(isLoading);

  return (
    <CardDefault>
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Text mb="16px" fontSize="18px">
          Dados Cadastrais
        </Text>

        <Box as={Row} gutter={32} mb={4}>
          <Box as={Col} xs={10} alignSelf="flex-end">
            <Field
              control={control}
              name="nome"
              label="Nome"
              rules={{ required: "Campo obrigatório" }}
            />
          </Box>

          <Box as={Col} xs={9} alignSelf="flex-end">
            <Field
              control={control}
              name="documento"
              label="CPF"
              rules={{
                required: "Campo obrigatório",
                validate: (v) => isValidCPF(v) || "CPF inválido",
              }}
              render={({ field, isInvalid }) => {
                return (
                  <InputMask
                    {...field}
                    isInvalid={isInvalid}
                    mask="999.999.999-99"
                    placeholder="XXX.XXX.XXX-XX"
                  />
                );
              }}
            />
          </Box>
          <Box as={Col} xs={5}>
            <Field
              control={control}
              name="imagemUrl"
              render={({ field }) => {
                return <UploadImagem {...field} confirmButton="Enviar foto" />;
              }}
            />
          </Box>
        </Box>

        <Box as={Row} gutter={32} mb={4}>
          <Box as={Col} xs={10}>
            <Field
              control={control}
              name="dataNascimento"
              label="Data de nascimento"
              rules={{ required: "Campo obrigatório" }}
              inputProps={{
                type: "date",
              }}
            />
          </Box>

          <Box as={Col} xs={5}>
            <Field
              control={control}
              name="sexo"
              label="Sexo"
              render={({ field }) => {
                return <SelectSexo {...field} />;
              }}
            />
          </Box>

          <Box as={Col} xs={9}>
            <Field
              control={control}
              name="email"
              label="Email"
              rules={{ required: "Campo obrigatório" }}
            />
          </Box>
        </Box>

        <Box as={Row}>
          <Box as={Col} xs={24}>
            <FormContatos control={control} />
          </Box>
        </Box>

        <Flex w="100%" justifyContent="flex-end" mt={16}>
          <PrimaryButton
            type="submit"
            isLoading={isLoadingSave || isFetching}
            disabled={!formState.isValid}
          >
            Salvar alterações
          </PrimaryButton>
        </Flex>
      </form>
    </CardDefault>
  );
}

export default DadosPessoaisTab;
